import React from "react";
import { Modal, ConfirmAbortModal } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { TSDIGITAL_ENDPOINT } from "../../../config";
import TextArea from "antd/lib/input/TextArea";
import { sendEmailFolder } from "../../../store/actions/folders";
import { useDispatch } from "react-redux";
import { displaySuccessToast } from "../../../store/actions/overflowNotification";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";

const FolderShareDialog = props => {
  const { idToShare, onClose } = props;

  const [linkCopiato, setLinkCopiato] = useState(null);
  const [visibleSendMailDialog, setVisibleSendMailDialog] = useState(false);
  const [msgTextValue, setMsgTextValue] = useState("");

  const dispatch = useDispatch();

  const intl = useIntl();

  const copyToClipboard = () => {
    var textField = document.createElement("textarea");
    let url = `${TSDIGITAL_ENDPOINT}folders/${idToShare}/download`;
    textField.innerText = url;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
    setLinkCopiato(true);
  };

  const onSendEmail = () => {
    let downloadUrl = `${TSDIGITAL_ENDPOINT}folders/${idToShare}/download`;
    let bodyRequest = {
      downloadLink: downloadUrl,
      message: msgTextValue
    };
    dispatch(sendEmailFolder(idToShare,
      bodyRequest));
    dispatch(displaySuccessToast(<FormattedMessage id="folders.pages.share.emailFeedback" />, ""));
    setVisibleSendMailDialog();
  };

  const renderSendEmailDialog = () => {
    return (
      <ConfirmAbortModal
        visible={visibleSendMailDialog}
        title={<FormattedMessage id="folders.pages.share.modalTitle" />}
        abortText={<FormattedMessage id="actions.cancel" />}
        confirmText={<FormattedMessage id="generic.send" />}
        onAbort={e => {
          setVisibleSendMailDialog();
        }}
        onConfirm={async() => {
          if (window.aptrinsic) {
            window.aptrinsic("track", "digital-box:FOLDERS-SHARE-EMAIL");
          }
          onSendEmail();
        }}
        type="primary"
      >
        <div
          style={{ width: "340px", marginTop: "25px", marginBottom: "12px" }}
        >
          <FormattedMessage id="folders.pages.share.message" />
        </div>
        <TextArea
          className="vaporTextarea"
          label="Messaggio"
          autoSize="true"
          value={msgTextValue}
          onChange={e => {
            setMsgTextValue(e.target.value);
          }}
          placeholder={intl.formatMessage({id:"folders.pages.share.placeholder"})}
        />
      </ConfirmAbortModal>
    );
  };

  return (
    <React.Fragment>
      <Modal
        visible={idToShare ? true : false}
        title={<FormattedMessage id="folders.pages.share.title" />}
        onClose={() => onClose()}
        type="primary"
      >
        <div className="shareFolder">
          <FormattedMessage id="folders.pages.share.description" />
        </div>
        <div className="shareFolderLinks">
          <div>
            <div
              className="imageShare"
              style={{ cursor: "pointer" }}
              onClick={() => copyToClipboard()}
            >
              <FontAwesomeIcon icon={["far", "link"]} className="shareIcon" />
            </div>
            {!linkCopiato ? (
              <div
                style={{
                  width: "75px",
                  height: "28px",
                  position: "relative",
                  textAlign: "center",
                  color: "#152935",
                  fontSize: "13px",
                  lineHeight: "2"
                }}
              >
                <FormattedMessage id="folders.pages.share.copy" />
              </div>
            ) : (
              <div
                style={{
                  width: "75px",
                  height: "28px",
                  position: "relative",
                  textAlign: "center",
                  color: "#0090d1",
                  fontSize: "12px",
                  lineHeight: "2"
                }}
              >
                <FormattedMessage id="folders.pages.share.copied" />
              </div>
            )}
          </div>
          <div>
            <div
              className="imageShare"
              style={{ cursor: "pointer" }}
              onClick={() => setVisibleSendMailDialog(true)}
            >
              <FontAwesomeIcon
                icon={["far", "envelope"]}
                className="shareIcon"
              />
            </div>
            <div
              style={{
                width: "60px",
                height: "28px",
                position: "relative",
                textAlign: "center",
                color: "#152935",
                fontSize: "13px",
                lineHeight: "2"
              }}
            >
              <FormattedMessage id="folders.pages.share.email" />
            </div>
          </div>
        </div>
      </Modal>
      {renderSendEmailDialog()}
    </React.Fragment>
  );
};

export default FolderShareDialog;
